import React from "react";
import { TextField } from "@material-ui/core";
import NumberFormat from "react-number-format";

const StandardNumberFormat = props => {
  const { inputRef, value, onChange, ...other } = props;

  return (
    <NumberFormat
      isNumericString
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator
      allowNegative={false}
      value={value}
      {...other}
    />
  );
};
const StandardNumberInput = ({ label, fieldName, values, handleChange, classes, ...other }) => (
  <TextField
    type="text"
    label={label}
    name={fieldName}
    value={values[fieldName]}
    onChange={handleChange}
    InputLabelProps={{
      FormLabelClasses: {
        root: classes.labelRoot
      }
    }}
    InputProps={{
      classes: {
        input: classes.inputField
      },
      disableUnderline: true,
      inputComponent: StandardNumberFormat
    }}
    {...other}
  />
);
export default StandardNumberInput;
